import { render, staticRenderFns } from "./SingleSponsors.vue?vue&type=template&id=147dcbb8"
import script from "./SingleSponsors.vue?vue&type=script&lang=js"
export * from "./SingleSponsors.vue?vue&type=script&lang=js"
import style0 from "./SingleSponsors.vue?vue&type=style&index=0&id=147dcbb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports